export default __webpack_public_path__ + "static/media/half-circle-loader.bda90766.svg";